import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Utils/Loader";
// note: can not get local storage in manifest.json so in manifest.json give this page path and on this page now will redirect dynamically to my catalogue
function TwaShortcutMyCatalogue() {
  const navigate = useNavigate();

  useEffect(() => {
    const catalogueId = localStorage.getItem("Ca1itd");

    if (catalogueId) {
      navigate(`/Catlogue/${catalogueId}`);
    } else {
      navigate("/"); // Fallback in case ID is missing
    }
  }, [navigate]);
  return (
    <div>
      <Loader />
    </div>
  );
}

export default TwaShortcutMyCatalogue;
